import Toastify from 'toastify-js';
import {
  Select,
  PhoneInput,
} from '@common/vanilla_ui/general';
import { apiRequest } from '@common/api/utils';
import CaseUtil from '@common/lib/caseUtil';
import {
  getPlatform,
  getAttribution,
  setAttribution,
} from '@common/vanilla_ui/tracking/attribution';
import { retryWithRecaptchaV2Params } from '@common/utils/recaptcha';
import { PROGRAM_PAGE_URL } from './constants';

const PHONE_NUMBER_SCREEN = document.getElementById('rcb-phone-number');
const ADDITIONAL_FIELD_SCREEN = document.getElementById('additional-field');
const PROGRAM_SELECT_SCREEN = document.getElementById('rcb-program-select');
const QUESTION_SELECT_SCREEN = document.getElementById('rcb-question-select');
const OTP_SELECT_SCREEN = document.getElementById('rcb-otp-select');
const SUCCESS_SCREEN = document.getElementById('rcb-success-msg');
const POSITION_FIELD_ID = 'scaler-rcb-form-otp-position';
const recaptchaInputSelector = '.g-recaptcha-response';
const recaptchaId = 'g-recaptcha-response';

const emailErrorEl = document.getElementsByClassName('email-error')[0];
const nameErrorEl = document.getElementsByClassName('name-error')[0];
const yearErrorEl = document.getElementsByClassName('year-error')[0];
const otpErrorEl = document.getElementsByClassName('otp-error')[0];

const GRAD_YEAR_IDS = [
  'box-year-0',
  'box-year-1',
  'box-year-2',
  'box-year-3',
];
const OTP_IDS = [
  'box-otp-0',
  'box-otp-1',
  'box-otp-2',
  'box-otp-3',
  'box-otp-4',
  'box-otp-5',
];
const PROGRAM_IDS = [
  'program-software-developer',
  'program-data-science',
  'program-ug',
  'program-post-ug',
];
const QUESTION_IDS = [
  'target-role-company',
  'what-other-do',
  'what-enrolment-process',
  'more-details-about-program',
  'more-info-about-placement',
  'other',
];

const phoneNumberInput = document.getElementById(
  'scaler-rcb-form__phone-number',
);
const phoneCountryCode = document.getElementById(
  'input-scaler-rcb-form__phone-code',
);
const otpPhoneCodeOtp = document.getElementById(
  'input-scaler-rcb-form__phone-otp-code',
);
const nameField = document.getElementById(
  'scaler-rcb-form__name',
);
const emailField = document.getElementById(
  'scaler-rcb-form__email',
);
const currentRole = document.getElementById(
  'input-scaler-rcb-form-otp-position',
);
const otpPhoneNumberField = document.getElementById(
  'scaler-rcb-form__phone-otp-number',
);
const otpResendCta = document.getElementById(
  'rcb-resend-otp',
);
const changeSelectedProgram = document.getElementById(
  'change-selected-program',
);
const phoneNumberEditBtn = document.getElementById(
  'phone-edit-btn',
);
const phoneEditProceedBtn = document.getElementById(
  'rcb-number-select-proceed',
);
const otpSection = document.getElementById(
  'otp-section',
);
const otpSectionRecaptcha = document.getElementById(
  'rcb-resend-recaptcha-tag',
);
const editRecaptchaEl = document.getElementById(
  'edit-recaptcha-tag',
);
const PROCEED_PHONE_NUMBER_SCREEN = document.getElementById(
  'rcb-phone-number-proceed',
);
const PROCEED_ADDITIONAL_FIELD_SCREEN = document.getElementById(
  'additional-field-proceed',
);
const PROCEED_QUESTION_SELECT_SCREEN = document.getElementById(
  'rcb-question-select-proceed',
);
const PROCEED_OTP_SELECT_SCREEN = document.getElementById(
  'rcb-otp-select-proceed',
);

const headerOptions = {
  headers: {
    'App-Name': CaseUtil.titleCase(getPlatform()),
  },
};

let timer;
function countdown(id, tragetNode) {
  clearInterval(timer);
  const timerElement = document.getElementById(id);
  timerElement.style.display = 'block';
  const tragetNodeEl = document.getElementById(tragetNode);
  tragetNodeEl.classList.add('hidden');
  let timeLeft = 60;

  timer = setInterval(() => {
    if (timeLeft > 0) {
      timeLeft -= 1;
      timerElement.textContent = `Resend OTP in ${timeLeft}s`;
    } else {
      clearInterval(timer);
      timerElement.textContent = '';
      tragetNodeEl.classList.remove('hidden');
      timerElement.style.display = 'none';
    }
  }, 1000);
}

const PROGRAM_PRODUCT_MATCHING = {
  'Software Development': 'software_development',
  'Data Science & Machine Learning': 'data_science',
  'Post Graduate Program (M.Sc)': 'neovarsity',
  'Under Graduate Program (B.Sc)': 'undergrad',
};

const setRcbAttribution = (program) => {
  const currentAttribution = getAttribution();
  setAttribution(
    currentAttribution.intent,
    {
      program: PROGRAM_PRODUCT_MATCHING[program],
    },
  );
};

export default function initializeRCB() {
  const paramsObj = {
    year: [],
    otp: [],
    program: '',
    selectedQuestions: [],
  };

  const formFlowEl = document.querySelector('#request-callback-form');
  const loggedIn = formFlowEl.getAttribute('data-logged-in') === 'true';

  PROCEED_PHONE_NUMBER_SCREEN.addEventListener('click', async () => {
    // check user exists or not
    // const payload = {
    //   payload: `+91-${phoneNumberInput.value}`,
    // };
    // const json = await apiRequest(
    //   'POST',
    //   '/api/v3/auth/check-user',
    //   payload,
    //   headerOptions,
    // );
    // if (json.new_user) {
    PHONE_NUMBER_SCREEN.classList.add('hidden');
    ADDITIONAL_FIELD_SCREEN.classList.remove('hidden');
    // } else {
    //   PROGRAM_SELECT_SCREEN.classList.remove('hidden');
    // }
  });
  PROCEED_ADDITIONAL_FIELD_SCREEN.addEventListener('click', () => {
    ADDITIONAL_FIELD_SCREEN.classList.add('hidden');
    if (!paramsObj.program) {
      PROGRAM_SELECT_SCREEN.classList.remove('hidden');
    } else {
      QUESTION_SELECT_SCREEN.classList.remove('hidden');
    }
  });

  async function handleRequestCallBackReq(recaptchId, phoneField) {
    const recaptchaEl = recaptchId.querySelector(
      recaptchaInputSelector,
    );
    const endpoint = loggedIn
      ? '/request-callback' : '/users/v2/';

    let payload = {};
    setRcbAttribution(paramsObj.program);
    if (!loggedIn) {
      payload = {
        [recaptchaId]: recaptchaEl?.value,
        ...retryWithRecaptchaV2Params('scaler-rcb-form-otp'),
        type: 'marketing',
        user: {
          country_code: otpPhoneCodeOtp.value,
          email: emailField.value,
          lead_identification: paramsObj.selectedQuestions,
          name: nameField.value,
          orgyear: paramsObj.year.join(''),
          phone: phoneField.value,
          phone_number: `${otpPhoneCodeOtp.value}-${phoneField.value}`,
          position: currentRole.value,
          program: paramsObj.program,
          skip_existing_user_check: true,
        },
      };
    } else {
      payload = {
        attributions: getAttribution(),
        user: {
          program: paramsObj.program,
          rcb_prams: {
            lead_identification: paramsObj.selectedQuestions,
          },
        },
      };
    }
    try {
      await apiRequest(
        'POST',
        endpoint,
        payload,
        headerOptions,
      );
      if (!loggedIn) {
        Toastify({
          text: 'You will receive OTP shortly',
          className: 'toastify-success',
        }).showToast();
        otpSection.click();
        QUESTION_SELECT_SCREEN.classList.add('hidden');
        OTP_SELECT_SCREEN.classList.remove('hidden');
        countdown('resend-timer', 'rcb-resend-otp');
      } else {
        QUESTION_SELECT_SCREEN.classList.add('hidden');
        SUCCESS_SCREEN.classList.remove('hidden');
      }
    } catch (err) {
      Toastify({
        text: 'Please try after sometime',
        className: 'toastify-danger',
      }).showToast();
    }
  }
  PROCEED_QUESTION_SELECT_SCREEN.addEventListener('click', async () => {
    PROCEED_QUESTION_SELECT_SCREEN.classList.remove('active-rcb');
    changeSelectedProgram.style.pointerEvents = 'none';
    handleRequestCallBackReq(PHONE_NUMBER_SCREEN, phoneNumberInput);
  });
  async function resendOtp() {
    document.removeEventListener('recaptcha-loaded', resendOtp);
    countdown('resend-timer', 'rcb-resend-otp');
    Toastify({
      text: 'You will receive OTP shortly',
      className: 'toastify-success',
    }).showToast();
    const recaptchaEl = otpSectionRecaptcha?.querySelector(
    recaptchaInputSelector,
  );
    if (!recaptchaEl?.value) {
      return;
    }
    const payload = {
      [recaptchaId]: recaptchaEl?.value,
      ...retryWithRecaptchaV2Params('scaler-rcb-form-otp'),
      user: {
        // email: emailField.value,
        phone_number: `${otpPhoneCodeOtp.value}-${otpPhoneNumberField.value}`,
      },
    };
    await apiRequest(
      'POST',
      '/users/v2/sessions',
      payload,
      headerOptions,
    );
    Toastify({
      text: 'You will receive the verification code shortly',
      className: 'toastify-info',
    }).showToast();
  }
  otpResendCta.addEventListener('click', () => {
    otpSectionRecaptcha.classList.remove('hidden');
    document.addEventListener('recaptcha-loaded', resendOtp);
  });
  PROCEED_OTP_SELECT_SCREEN.addEventListener('click', async () => {
    PROCEED_OTP_SELECT_SCREEN.classList.remove('active-rcb');
    const payload = {
      user: {
        email: emailField.value,
        phone_number: `${phoneCountryCode.value}-${otpPhoneNumberField.value}`,
        otp: paramsObj.otp.join(''),
        request_callback: 'true',
        program: paramsObj.program,
        rcb_prams: paramsObj.selectedQuestions,
        position: currentRole.value,
      },
      attributions: getAttribution(),
    };
    try {
      await apiRequest(
        'POST',
        '/users/v2/verify',
        payload,
        headerOptions,
      );
      OTP_SELECT_SCREEN.classList.add('hidden');
      SUCCESS_SCREEN.classList.remove('hidden');
    } catch {
      otpErrorEl.style.display = 'block';
      Toastify({
        text: 'Incorrect OTP',
        className: 'toastify-danger',
      }).showToast();
    }
  });

  if (document.getElementById(POSITION_FIELD_ID)) {
    new PhoneInput('scaler-rcb-form__phone');
    new PhoneInput('scaler-rcb-form__phone-otp');
    new Select(POSITION_FIELD_ID);
  }

  phoneNumberInput.addEventListener('keydown', (e) => {
    // Get the key code of the pressed key
    const keyCode = e.keyCode || e.which;

    // Allow only numeric keys (0-9) and
    // specific control keys (Backspace and Delete)
    if (
      (keyCode < 48 || keyCode > 57)
      && keyCode !== 8 && keyCode !== 46
    ) {
      e.preventDefault();
    }
  });

  phoneNumberInput.addEventListener('input', (e) => {
    const indianPhoneNumberRegex = /^[6789]\d{9}$/;
    const worlwidePhoneNumberRegex = /^\d{1,15}$/;
    const { value } = e.target;

    if (
      phoneCountryCode.value === '+91'
      && indianPhoneNumberRegex.test(value)
    ) {
      PROCEED_PHONE_NUMBER_SCREEN.classList.add('active-rcb');
      otpPhoneNumberField.value = value;
    } else if (
      phoneCountryCode.value !== '+91'
      && worlwidePhoneNumberRegex.test(value)
    ) {
      PROCEED_PHONE_NUMBER_SCREEN.classList.add('active-rcb');
      otpPhoneNumberField.value = value;
    } else {
      PROCEED_PHONE_NUMBER_SCREEN.classList.remove('active-rcb');
    }
  });

  function validateYear(year) {
    const currentYear = new Date().getFullYear();
    if (Number.isInteger(year) && year >= 1970 && year <= currentYear + 4) {
      yearErrorEl.style.display = 'none';
      return true;
    } else {
      yearErrorEl.style.display = 'block';
      return false;
    }
  }

  function validateAdditonForm() {
    const nameRegex = /^[a-zA-Z\s]+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const year = paramsObj.year.filter(item => item !== '').join('');
    if (
      nameRegex.test(nameField.value)
      && emailRegex.test(emailField.value)
      && year.length === 4
      && validateYear(Number(year))
      && currentRole.value
    ) {
      PROCEED_ADDITIONAL_FIELD_SCREEN.classList.add('active-rcb');
    } else {
      PROCEED_ADDITIONAL_FIELD_SCREEN.classList.remove('active-rcb');
    }
    if (!nameField.value || nameRegex.test(nameField.value)) {
      nameErrorEl.style.display = 'none';
    } else {
      nameErrorEl.style.display = 'block';
    }

    if (!emailField.value || emailRegex.test(emailField.value)) {
      emailErrorEl.style.display = 'none';
    } else {
      emailErrorEl.style.display = 'block';
    }
  }

  function handleBoxStyleInput(id, index, arr, slug, cb) {
    const el = document.getElementById(id);
    el.addEventListener('input', (e) => {
      const eventCode = e.inputType;
      const value = Number(e.target.value);
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(value) && eventCode !== 'deleteContentBackward') {
        el.value = '';
        paramsObj[slug][index] = '';
      } else {
        paramsObj[slug][index] = value;
        if (eventCode === 'deleteContentBackward' && index !== 0) {
          paramsObj[slug][index] = '';
          document.getElementById(arr[index - 1]).focus();
        } else if (eventCode === 'deleteContentBackward' && index === 0) {
          paramsObj[slug][index] = '';
          document.getElementById(arr[index]).focus();
        } else if (arr[index + 1]) {
          document.getElementById(arr[index + 1]).focus();
        }
      }
      cb();
    });
    el.addEventListener('keydown', (e) => {
      if (e.which === 8 && e.target.value === '' && index !== 0) {
        document.getElementById(arr[index - 1]).focus();
        e.preventDefault();
      } else if (
        e.which !== 8
        && e.target.value
        && document.getElementById(arr[index])
        && document.getElementById(arr[index + 1])
      ) {
        document.getElementById(arr[index + 1]).focus();
      } else if (
        e.which !== 8
        && e.target.value
        && document.getElementById(arr[index])
        && !document.getElementById(arr[index + 1])
      ) {
        e.preventDefault();
      }

      // on enter submit form
      if (slug === 'otp' && e.key === 'Enter') {
        PROCEED_OTP_SELECT_SCREEN.click();
      }
    });
  }

  GRAD_YEAR_IDS.forEach((id, index) => {
    handleBoxStyleInput(
      id, index, GRAD_YEAR_IDS, 'year', validateAdditonForm,
    );
  });

  function sanityOtpInput() {
    const otp = paramsObj.otp.filter(item => item !== '').join('');
    if (otp.length === 6) {
      PROCEED_OTP_SELECT_SCREEN.classList.add('active-rcb');
    } else {
      PROCEED_OTP_SELECT_SCREEN.classList.remove('active-rcb');
    }
    otpErrorEl.style.display = 'none';
  }

  OTP_IDS.forEach((id, index) => {
    handleBoxStyleInput(id, index, OTP_IDS, 'otp', sanityOtpInput);
  });

  document.getElementById(OTP_IDS[0]).onpaste = (e) => {
    let pastedOtp = e.clipboardData.getData('text');
    pastedOtp = Number(pastedOtp)?.toString();
    pastedOtp = pastedOtp.split('');
    if (pastedOtp.length === 6) {
      paramsObj.otp = [];
      OTP_IDS.forEach((id, index) => {
        document.getElementById(id).value = pastedOtp[index];
        paramsObj.otp.push(pastedOtp[index]);
        if (index === 5) document.getElementById(id).focus();
      });
    }
    e.preventDefault();
    sanityOtpInput();
  };

  nameField.addEventListener('input', () => {
    validateAdditonForm();
  });
  emailField.addEventListener('input', () => {
    validateAdditonForm();
  });
  currentRole.addEventListener('input', () => {
    validateAdditonForm();
  });


  PROGRAM_IDS.forEach(id => {
    const el = document.getElementById(id);
    el.addEventListener('click', () => {
      paramsObj.program = el.value;
      paramsObj.selectedProgramId = id;
      el.parentNode.classList.add('active-program-select');
      setTimeout(() => {
        PROGRAM_SELECT_SCREEN.classList.add('hidden');
        QUESTION_SELECT_SCREEN.classList.remove('hidden');
        document.getElementById('selected-program-value').innerText = el.value;
        el.parentNode.classList.remove('active-program-select');
      }, 1000);
    });
    /*
      to select the program by default
    */
    PROGRAM_PAGE_URL[id]?.forEach(path => {
      if (window.location.href.includes(path)) {
        paramsObj.program = el.value;
        paramsObj.selectedProgramId = id;
        document.getElementById('selected-program-value').innerText = el.value;
      }
    });
  });

  changeSelectedProgram.addEventListener('click', () => {
    PROGRAM_SELECT_SCREEN.classList.remove('hidden');
    QUESTION_SELECT_SCREEN.classList.add('hidden');
    document.getElementById(paramsObj.selectedProgramId).checked = false;
  });

  QUESTION_IDS.forEach(id => {
    const el = document.getElementById(id);
    el.addEventListener('click', () => {
      paramsObj.selectedQuestions = [];
      QUESTION_IDS.forEach(i => {
        const iEl = document.getElementById(i);
        if (iEl.checked) paramsObj.selectedQuestions.push(iEl.value);
      });
      if (paramsObj.selectedQuestions.length > 0) {
        PROCEED_QUESTION_SELECT_SCREEN.classList.add('active-rcb');
      } else {
        PROCEED_QUESTION_SELECT_SCREEN.classList.remove('active-rcb');
      }
    });
  });

  phoneNumberEditBtn.addEventListener('click', () => {
    phoneNumberEditBtn.classList.add('hidden');
    phoneEditProceedBtn.classList.remove('hidden');
    PROCEED_OTP_SELECT_SCREEN.classList.add('hidden');
    otpSection.classList.add('hide-otp');
    editRecaptchaEl.classList.remove('hidden');
    otpResendCta.classList.add('hidden');
    otpSectionRecaptcha.classList.add('hidden');
    otpPhoneNumberField.removeAttribute('disabled');
  });

  phoneEditProceedBtn.addEventListener('click', () => {
    phoneNumberEditBtn.classList.remove('hidden');
    phoneEditProceedBtn.classList.add('hidden');
    PROCEED_OTP_SELECT_SCREEN.classList.remove('hidden');
    otpSection.classList.remove('hide-otp');
    handleRequestCallBackReq(editRecaptchaEl, otpPhoneNumberField);
    countdown('resend-timer', 'rcb-resend-otp');
    editRecaptchaEl.classList.remove('hidden');
    otpPhoneNumberField.setAttribute('disabled');
  });
}
